import React, { useState } from 'react';
import { PageTitle, Button } from '@cordata/buffet';
import { toast } from 'react-toastify';
import kebabcaseKeys from 'kebabcase-keys';
import { compact } from 'lodash';

import {
  authorizedRbInstance as Api,
} from '~/utils';

import Form from './Form';
import Collection from './Collection';
import Details from './Details';

const BatchImportMegaCollection = () => {
  const [id, setId] = useState(undefined);

  const handleSubmit = (values, bag) => {
    if (values.validFile) {
      const p = kebabcaseKeys({
        ...values,
        file: compact(values.file
          .map(f => (
            f.data.length === 1 && f.data[0] === '' ? '' : f.data
          ))),
      }, { deep: true });
      const params = kebabcaseKeys({
        divisionUid: values.division.id,
      }, { deep: true });

      delete p.organization;
      delete p.division;
      delete p.dataType;
      delete p.schema;

      Api
        .post(`/admin/batch-imports/import/csv/${values.dataType.attributes.name}`, p, { params })
        .then((r) => {
          toast.success('Successfully saved!');
          if (r) {
            setId();
          }
        })
        .catch((e) => {
          console.error(e);
          bag.setErrors(e);
          toast.error('Oops! Something went wrong');
        })
        .then(() => {
          bag.setSubmitting(false);
        });
    } else {
      toast.error('invalid file');
    }
  };

  const handleItemClick = (e, handleOriginal, rowInfo) => (handleOriginal
    ? handleOriginal()
    : setId(rowInfo.original.id));

  return (
    <div>
      <PageTitle
        action={
          <Button outline icon="plus" size="sm" onClick={() => setId('add')}>
            Start an import
          </Button>
        }
      >
        Batch Import
      </PageTitle>

      <Collection
        onClick={handleItemClick}
      />

      {!!id && id === 'add' && <Form
        id={id}
        handleSubmit={handleSubmit}
        handleCancel={() => setId()}
      />}

      {!!id && id !== 'add' && <Details
        id={id}
        handleCancel={() => setId()}
      />}
    </div>
  );
};

export default BatchImportMegaCollection;
